module.exports = __webpack_public_path__ + "assets/img/logo_visa@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_visa@2x.png
// module id = 124
// module chunks = 0